<template>
    <div class="login">
        <v-container>
            <v-row justify="center">
                <v-col sm="12" md="8" class="my-10">
                    <v-card max-width="1000" class="ma-5">
                        <v-row justify="center">
                            <v-card-title class="mt-5 info--text">Login your account</v-card-title>
                        </v-row>
                        <v-row class="mx-10 my-5">
                            <v-text-field
                            v-model="email"
                            :error-messages="emailErrors"
                            label="Email"
                            required
                            @input="$v.email.$touch()"
                            @blur="$v.email.$touch()"
                            ></v-text-field>
                        </v-row>
                        <v-row class="mx-10 mt-10">
                            <v-text-field
                            v-model="password"
                            :append-icon="show1 ? 'visibility' : 'visibility_off'"
                            label="Password"
                            required
                            @input="$v.password.$touch()"
                            @blur="$v.password.$touch()"
                            :type="show1 ? 'text' : 'password'"
                            @click:append="show1 = !show1"
                            ></v-text-field>
                        </v-row>
                        <v-row class="mx-10 pt-3 pb-8 caption red--text" justify="center">
                            <v-col cols="12"><p class="center" v-if="feedback">{{feedback}}</p></v-col>
                            <v-btn
                            color="primary"
                            class="info--text"
                            @click="submit"
                            width="120"
                            small
                            >
                            Login
                            </v-btn>
                            <v-btn
                            color="error"
                            class=""
                            @click="clear"
                            width="120"
                            small
                            text
                            >
                            Clear Form
                            </v-btn>
                        </v-row>
                        <v-row justify="center">
                            <p class="pb-7 center" v-if="successfeedback">{{successfeedback}}</p>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email} from 'vuelidate/lib/validators'
import {auth} from '@/fb'

export default {
    name:'login',
    mixins: [validationMixin],

    validations: {
      email: { required, email },
      password: {
        required,
      },
    },
    data(){
        return {
            email:'',
            password:'',
            feedback:null,
            successfeedback:null,
            show1:false
        }
    },
    computed:{
        emailErrors () {
            const errors = []
            if (!this.$v.email.$dirty) return errors
            !this.$v.email.email && errors.push('Must be valid e-mail')
            !this.$v.email.required && errors.push('E-mail is required')
            return errors
        },
    },
    methods:{
       submit () {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.feedback = 'You must enter all fields'
            } else {
                // do your submit logic here
                if(this.email.includes('@tpo.')||this.email.includes('@TPO.')){
                    auth.signInWithEmailAndPassword(this.email,this.password)
                    .then(()=>{
                        this.successfeedback = 'successfully logged in'
                        this.$router.push({name:'dashboard'})
                    })
                    .catch(error => {
                        /* eslint-disable no-console */
                        console.log(error)
                        /* eslint-enable no-console */
                        this.feedback = error.message
                    })
                }
                else{
                    this.feedback = 'Please contact YourConcierge Team'
                }
            }
        },
        clear () {
            this.$v.$reset()
            this.name = ''
            this.email = ''
            this.password = ''
            this.repeatpassword = ''
        },
    },
    created(){
        if(auth.currentUser){
            this.$router.push({name:'dashboard'})
        }
    }
}
</script>